/**
 * @module messages
 *
 * @description
 * A collection of classes to construct WhatsApp API messages.
 *
 * There are 7 types of messages:
 * - {@link Text}
 * - {@link Media}
 * - {@link Template}
 * - {@link Interactive}
 * - {@link Location}
 * - {@link Contacts}
 * - {@link Reaction}
 */

export * from "./text.js";
export * from "./location.js";
export * from "./reaction.js";
export * from "./contacts.js";
export * from "./interactive.js";
export * from "./media.js";
export * from "./template.js";
export * from "./globals.js";
